// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.actions[data-v-0236b34a] .edit-button + *, .edit-button[data-v-0236b34a] {\n\tmargin-left: 10px;\n}\n.actions[data-v-0236b34a] {\n\t-ms-flex-negative: 0;\n\t    flex-shrink: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
